import { render } from "./process-pdal.vue?vue&type=template&id=65795626&ts=true&lang=pug"
import script from "./process-pdal.vue?vue&type=script&lang=ts"
export * from "./process-pdal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__